import React, { useEffect, useState, useRef, Component } from 'react';
import { X as XIcon, Search as SearchIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface SearchOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}
const popularSearches = ['Essential Oils', 'Lavender', 'Diffusers', 'Tea Tree', 'Gift Sets'];
const SearchOverlay: React.FC<SearchOverlayProps> = ({
  isOpen,
  onClose
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // In a real app, this would navigate to search results
      console.log(`Searching for: ${searchQuery}`);
      onClose();
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center pt-24 px-4" data-id="element-440">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl overflow-hidden" data-id="element-441">
        <div className="relative p-4" data-id="element-442">
          <button onClick={onClose} className="absolute right-4 top-4 text-gray-500 hover:text-gray-700" data-id="element-443">
            <XIcon className="h-6 w-6" data-id="element-444" />
          </button>
          <form onSubmit={handleSubmit} className="mt-2" data-id="element-445">
            <div className="relative" data-id="element-446">
              <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-447" />
              <input ref={inputRef} type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search for products..." className="w-full pl-12 pr-4 py-3 border-b-2 border-gray-200 focus:border-[#2e7d32] outline-none text-lg" data-id="element-448" />
            </div>
          </form>
        </div>
        {searchQuery ? <div className="px-4 pb-6" data-id="element-449">
            <p className="text-sm text-gray-500 mb-4" data-id="element-450">
              Press Enter to search for "{searchQuery}"
            </p>
          </div> : <div className="px-4 pb-6" data-id="element-451">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-452">
              Popular Searches
            </h3>
            <div className="flex flex-wrap gap-2" data-id="element-453">
              {popularSearches.map((term, index) => <Link key={index} to={`/products?search=${encodeURIComponent(term)}`} onClick={onClose} className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm text-gray-700" data-id="element-454">
                  {term}
                </Link>)}
            </div>
          </div>}
      </div>
    </div>;
};
export default SearchOverlay;